<form [formGroup]="form" (ngSubmit)="onSave()">
	@if (httpError) {
	<mat-error class="top-right-absolute-error-message">{{ 'masterdata.racking.dialog.httperror' | translate }}</mat-error>
	}

	<h1 mat-dialog-title class="notification-title">{{ 'masterdata.racking.rack' | translate }}</h1>

	<mat-dialog-content style="padding-top: 20px">
		<mat-form-field appearance="outline" class="dialog">
			@if (controls['name'].invalid && controls['name'].touched) {
			<mat-error>{{ 'masterdata.racking.dialog.name.errors.empty' | translate }}</mat-error>
			}
			<mat-label class="mat-body-1">{{ 'masterdata.racking.dialog.name.label' | translate }}</mat-label>
			<input maxlength="50" matInput formControlName="name" />
		</mat-form-field>

		<mat-form-field appearance="outline" class="dialog">
			<mat-label class="mat-body-1">{{ 'masterdata.racking.description' | translate }}</mat-label>
			<input maxlength="100" matInput formControlName="description" />
		</mat-form-field>

		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				@if (controls['rows'].invalid && controls['rows'].touched) {
				<mat-error>{{ 'masterdata.racking.dialog.rows.limit-error' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.racking.dialog.rows.label' | translate }}</mat-label>
				<input OnlyNumbers matInput formControlName="rows" />
			</mat-form-field>

			<div class="spacer"></div>
			<!-- Add white space here -->

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.racking.dialog.columns.label' | translate }}</mat-label>
				<mat-error>{{ 'masterdata.racking.dialog.columns.limit-error' | translate }}</mat-error>
				<input OnlyNumbers matInput formControlName="columns" />
			</mat-form-field>
		</div>

		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.racking.dialog.cells.width.label' | translate }}</mat-label>
				<mat-error>{{ 'masterdata.racking.dialog.cells.width.limit-error' | translate }}</mat-error>
				<input OnlyNumbers matInput formControlName="width" />
			</mat-form-field>

			<div class="spacer"></div>
			<!-- Add white space here -->

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.racking.dialog.cells.height.label' | translate }}</mat-label>
				<mat-error>{{ 'masterdata.racking.dialog.cells.height.limit-error' | translate }}</mat-error>
				<input OnlyNumbers matInput formControlName="height" />
			</mat-form-field>

			<div class="spacer"></div>
			<!-- Add white space here -->

			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.racking.dialog.cells.depth.label' | translate }}</mat-label>
				<mat-error>{{ 'masterdata.racking.dialog.cells.depth.limit-error' | translate }}</mat-error>
				<input OnlyNumbers matInput formControlName="depth" />
			</mat-form-field>
		</div>

		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				@if (controls['capacity'].invalid && controls['capacity'].touched) {
				<mat-error>{{ 'masterdata.racking.dialog.capacity.errors.empty' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.racking.dialog.capacity.label' | translate }}</mat-label>
				<input OnlyNumbers matInput formControlName="capacity" />
			</mat-form-field>

			<div class="spacer"></div>
			<!-- Add white space here -->

			<mat-form-field appearance="outline" class="dialog">
				@if (controls['components'].invalid && controls['components'].touched) {
				<mat-error>{{ 'masterdata.racking.dialog.components.errors.empty' | translate }}</mat-error>
				}
				<mat-label class="mat-body-1">{{ 'masterdata.racking.dialog.components.label' | translate }}</mat-label>
				<mat-select formControlName="components" multiple>
					@for (component of translationComponents; track component) {
					<mat-option [value]="getComponent(component.type.self)">{{ ('masterdata.racking.components.' + getComponent(component.type.self)) | translate }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
		</div>

		<h3>{{ 'masterdata.racking.dialog.workCenterFilter.title' | translate }}</h3>

		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.racking.dialog.workCenterFilter.mode.label' | translate }}</mat-label>
				<mat-select formControlName="workCenterFilterMode">
					@for (mode of workCenterFilterModes; track mode) {
					<mat-option [value]="mode">{{ 'masterdata.racking.dialog.workCenterFilter.mode.' + mode.toLowerCase() | translate }}</mat-option>
					}
				</mat-select>
			</mat-form-field>
		</div>

		<div class="dialog-container">
			<mat-form-field appearance="outline" class="dialog">
				<mat-label class="mat-body-1">{{ 'masterdata.racking.dialog.workCenterFilter.key' | translate }}</mat-label>
				<mat-chip-grid
					#workCenterChipGrid
					formControlName="workCenterFilterKeys"
					[errorStateMatcher]="workCenterEntryErrorState"
					[attr.aria-label]="
						'masterdata.racking.dialog.workCenterFilter.title' | translate
					">
					@for (key of workCenterFilterKeys; track key) {
					<mat-chip-row [value]="key" (removed)="removeWorkCenter(key)">
						{{ key }}
						<button
							matChipRemove
							type="button"
							[attr.aria-label]="
								'masterdata.racking.dialog.workCenterFilter.remove' | translate
							">
							<mat-icon svgIcon="acies_delete"></mat-icon>
						</button>
					</mat-chip-row>
					}
				</mat-chip-grid>
				<!-- Enter and blur commit a chip; matChipInput stops Enter submitting the dialog. -->
				<input maxlength="255" [formControl]="workCenterInput" [matChipInputFor]="workCenterChipGrid" [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="addWorkCenter()" />
				<mat-hint>{{ 'masterdata.racking.dialog.workCenterFilter.hint' | translate }}</mat-hint>
				@if (workCenterInput.errors?.['workCenterWhitespace']) {
				<mat-error>{{ 'masterdata.racking.dialog.workCenterFilter.errors.whitespace' | translate }}</mat-error>
				} @if (workCenterInput.errors?.['workCenterComma']) {
				<mat-error>{{ 'masterdata.racking.dialog.workCenterFilter.errors.comma' | translate }}</mat-error>
				} @if (workCenterInput.errors?.['workCenterPadded']) {
				<mat-error>{{ 'masterdata.racking.dialog.workCenterFilter.errors.padded' | translate }}</mat-error>
				} @if (workCenterInput.errors?.['workCenterDuplicate']) {
				<mat-error>{{ 'masterdata.racking.dialog.workCenterFilter.errors.duplicate' | translate }}</mat-error>
				} @if (controls['workCenterFilterKeys'].errors?.['workCenterFilterEmpty']) {
				<mat-error>{{ 'masterdata.racking.dialog.workCenterFilter.errors.empty' | translate }}</mat-error>
				}
			</mat-form-field>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-stroked-button type="button" (click)="onCancel()" (window:keyup.escape)="onCancel()" class="button-border-color">{{ 'masterdata.racking.dialog.cancel' | translate }}</button>
		<button mat-flat-button color="primary" type="submit" [disabled]="loading || form.invalid || workCenterInput.invalid" [ngClass]="{ 'disabled-button': loading }">{{ 'masterdata.racking.dialog.ok' | translate }}</button>
	</mat-dialog-actions>
</form>
